import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';

import { resources } from './resources';

import type { InitOptions } from 'i18next';

const i18n = i18next.createInstance();

const options: InitOptions = {
  debug: false,
  load: 'languageOnly',
  fallbackLng: 'en',
  react: {
    useSuspense: false,
  },
  supportedLngs: Object.keys(resources),
  resources,
  initImmediate: false,
};

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n.use(initReactI18next).init(options);

i18n.languages = ['en', 'de', 'fr', 'es', 'nl'];

export default i18n;
